<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import type { CareersProps } from "./CareersProps";
	import translations from "./Careers.translations.json";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import careerThumbnail from "../assets/images/careers/career_cover.jpg";
	import careerThumbnailSm from "../assets/images/careers/career_cover.jpg?webp&w=608&imagetools";
	import careerThumbnailMd from "../assets/images/careers/career_cover.jpg?webp&w=704&imagetools";
	import careerThumbnailLg from "../assets/images/careers/career_cover.jpg?webp&w=960&imagetools";
	import careerThumbnailXl from "../assets/images/careers/career_cover.jpg?webp&w=1424&imagetools";
	import CareerCard from "../components/Career/CareerCard.svelte";
	import Link from "../components/Link.svelte";
	import { aboutPathMap } from "../../../core/schema/paths/aboutPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";
	import arrowRightLong from "../../../core/assets/icons/arrow-right-long.svg?raw";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";

	type $$Props = CareersProps;

	const { positions } = $$restProps as $$Props;
	const { TENANT_LOCALE } = getGlobalSettings();

	const translate = getTranslate(translations);

	setContext(thumbnailImageContextKey, careerThumbnail);
</script>

<Layout>
	<section class="container">
		<div class="flex items-center overflow-hidden rounded-lg">
			<StaticPicture
				image={careerThumbnailXl}
				alt={translate("heading")}
				width={1920}
				height={0}
				loading="eager"
				class="flex h-auto w-full items-center justify-center md:max-h-[36.25rem] lg:h-[28.25rem]"
				imgClass="w-full h-full lg:h-auto object-cover"
				sourcesets={{
					"<md": careerThumbnailSm,
					">md": careerThumbnailMd,
					">lg": careerThumbnailLg,
					">xl": careerThumbnailXl,
				}}
			/>
		</div>
	</section>

	<div class="container flex flex-col md:items-center">
		<div class="lg:w-[50rem]">
			<h1 class="lg:text-3xl">{translate("heading")}</h1>
			<p class="text-2md font-spaceGrotesk mb-7 leading-snug">{translate("perex")}</p>
			<p>{translate("content1")}</p>
			<p>{translate("content2")}</p>
			<Link asButton icon={arrowRightLong} href={`/${aboutPathMap[TENANT_LOCALE]}`} class="text-primary underline"
				>{translate("readMoreAboutUs")}</Link
			>
		</div>
	</div>

	{#if positions.length > 0}
		<section class="container flex flex-col p-2 lg:!mt-[8.5rem] lg:flex-row lg:gap-16">
			<h2 class="p-8 lg:basis-80">{translate("openPositions")}</h2>
			<div class="grid flex-1 auto-rows-[minmax(33.75rem,auto)] grid-cols-1 gap-2 md:grid-cols-2">
				{#each positions as position}
					<CareerCard {position} />
				{/each}
			</div>
		</section>
	{:else}
		<section class="container flex flex-col md:items-center">
			<div class="lg:w-[50rem]">
				<p class="text-2md font-spaceGrotesk mb-7 leading-snug">{translate("currentlyNotHiringHeadline")}</p>
				<p>{translate("currentlyNotHiringContent")}</p>
			</div>
		</section>
	{/if}
</Layout>
